var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategoryNotEligibleSmall = function SvgCategoryNotEligibleSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D9E9",
    fillRule: "evenodd",
    d: "M21.63 33.323c-8.853 0-16.075-7.22-16.075-16.072S12.777 1.176 21.63 1.176s16.074 7.222 16.074 16.075-7.222 16.072-16.074 16.072",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C2CBDD",
    fillRule: "evenodd",
    d: "M8.414 17.25c0 3.289.987 6.346 2.68 8.893a16 16 0 0 0 2.262 2.704 16.02 16.02 0 0 0 9.703 4.414 16.2 16.2 0 0 1-3.73-.1l-.29-.045c-7.647-1.237-13.484-7.87-13.484-15.865 0-8.878 7.197-16.075 16.074-16.075q.723 0 1.43.063c-8.21.723-14.645 7.615-14.645 16.012",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5EAF3",
    fillRule: "evenodd",
    d: "M21.63 18.8c5.79 0 10.557 4.387 11.161 10.018a16.02 16.02 0 0 1-11.161 4.505 16.03 16.03 0 0 1-11.16-4.505c.602-5.633 5.37-10.018 11.16-10.018",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D8DFEE",
    fillRule: "evenodd",
    d: "M23.057 18.89c-6.681.85-9.373 5.905-9.992 11.963a16 16 0 0 1-2.595-2.035C11.07 23.185 15.839 18.8 21.629 18.8q.726 0 1.428.09",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.63 18.636a5.6 5.6 0 0 1-5.592-5.59 5.6 5.6 0 0 1 5.592-5.59 5.6 5.6 0 0 1 5.59 5.59 5.6 5.6 0 0 1-5.59 5.59",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7FB",
    fillRule: "evenodd",
    d: "M17.446 13.046a5.59 5.59 0 0 0 4.887 5.547q-.346.042-.703.043a5.59 5.59 0 1 1 .703-11.137 5.59 5.59 0 0 0-4.887 5.547",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE646F",
    fillRule: "evenodd",
    d: "M10.246 22.29 3.611 33.561a2.9 2.9 0 0 0 0 2.971 3.02 3.02 0 0 0 2.625 1.486h13.268a3.02 3.02 0 0 0 2.623-1.486 2.9 2.9 0 0 0 0-2.971l-6.634-11.27a3.02 3.02 0 0 0-2.623-1.488c-1.091 0-2.078.56-2.624 1.487",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FD4755",
    fillRule: "evenodd",
    d: "M13.274 20.83a3 3 0 0 0-.404-.027 3.02 3.02 0 0 0-2.623 1.487L3.61 33.561a2.9 2.9 0 0 0 0 2.971 3.02 3.02 0 0 0 2.625 1.486h.809a3.02 3.02 0 0 1-2.625-1.486 2.9 2.9 0 0 1 0-2.971l6.635-11.27a3 3 0 0 1 2.22-1.462",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEFF5",
    fillRule: "evenodd",
    d: "m11.615 23.064-6.636 11.27a1.38 1.38 0 0 0 0 1.424c.265.447.73.712 1.257.712h13.268c.526 0 .993-.265 1.256-.712a1.38 1.38 0 0 0 0-1.423l-6.634-11.27a1.43 1.43 0 0 0-1.256-.713c-.527 0-.992.264-1.255.712",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5AFC3",
    fillRule: "evenodd",
    d: "M18.695 36.47h.81c.525 0 .992-.265 1.255-.712a1.38 1.38 0 0 0 0-1.423l-6.634-11.27a1.43 1.43 0 0 0-1.256-.713q-.21.001-.405.055c.356.099.659.328.852.657l6.634 11.27c.263.449.263.976 0 1.424s-.73.712-1.256.712",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE646F",
    fillRule: "evenodd",
    d: "M12.869 31.857a.733.733 0 0 0 .74-.7l.188-5.084a.7.7 0 0 0-.208-.531.72.72 0 0 0-.533-.222h-.374a.72.72 0 0 0-.533.222.7.7 0 0 0-.208.53l.187 5.085c.014.39.342.7.74.7M12.87 34.69a.94.94 0 0 1-.949-.93.94.94 0 0 1 .948-.93.94.94 0 0 1 .948.93c0 .513-.425.93-.948.93",
    clipRule: "evenodd"
  })));
};
export default SvgCategoryNotEligibleSmall;